// 2026-11-05 (feedback pipeline, docs/product/feedback-pipeline.md): the Director's report drafts. report_problem and
// send_feedback no longer send anything: they return a `feedback_draft` directive, and the DraftCard (one for the
// whole app, DraftHost in App) shows the words with Send, Edit and Discard. Send is POST /api/feedback/:id/send
// {text?}, Discard is DELETE /api/feedback/:id. When the user says "send it" instead, the tool's result carries the
// same directive with state "sent" and the card says so. Pure state here (unit-tested in pipeline.test.ts).
import type { FeedbackDraftDirective } from "./types";

export type DraftState = "draft" | "sending" | "sent" | "discarded";
export type Draft = { id: string; kind: "problem" | "feedback"; text: string; state: DraftState; error?: string | null };

let current: Draft | null = null;
const subs = new Set<() => void>();
const emit = () => subs.forEach((f) => f());

/** The Director's directive: a new draft replaces the card; "sent" / "discarded" update the one on screen. */
export function showDraft(d: FeedbackDraftDirective): void {
  const state: DraftState = d.state === "sent" ? "sent" : d.state === "discarded" ? "discarded" : "draft";
  if (state === "discarded") {
    if (current?.id !== d.id) return;
    current = null;
  } else current = { id: d.id, kind: d.kind, text: d.text, state };
  emit();
}

/** Updates the card on screen (only if it's still the same draft). */
export function patchDraft(id: string, p: Partial<Omit<Draft, "id">>): void {
  if (!current || current.id !== id) return;
  current = { ...current, ...p };
  emit();
}

export function closeDraft(): void {
  if (!current) return;
  current = null;
  emit();
}

export const currentDraft = (): Draft | null => current;
export function subscribeDrafts(f: () => void): () => void {
  subs.add(f);
  return () => void subs.delete(f);
}
